const buildSubgroupStudents = (subgroupStudentIds, studentsBySection) => {
  const studentsById = Object.values(studentsBySection || {})
    // combine students into single array, we get an array of arrays
    .reduce((acc, current) => acc.concat(current), [])
    // get students that we care about and key them by their id
    .reduce((acc, current) => {
      const { id } = current;
      // keep only students we care about
      if ((subgroupStudentIds || []).includes(parseInt(id, 10))) {
        acc[parseInt(id, 10)] = current;
      }
      return acc;
    }, {});
  // get student names in the same order as subgroupStudentIds
  return (subgroupStudentIds || []).map(
    (student_id) =>
      studentsById[student_id] && {
        id: student_id,
        first_name: studentsById[student_id].firstName,
        last_name: studentsById[student_id].lastName,
      },
  );
};

export default buildSubgroupStudents;
